var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from '../core/model';
var AxisLabelHighlight = /** @class */ (function (_super) {
    __extends(AxisLabelHighlight, _super);
    function AxisLabelHighlight() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'axis-label-highlight';
        _this.handlePlotMouseMove = function (event) {
            var _a;
            _this._unhighlightLable(_this._activeLabelIndex);
            var x = event.mouse.x;
            var xAxis = event.target.xAxis[0];
            var index = Math.round(xAxis.scale.invert(x));
            var labels = xAxis.getTickLabels();
            _this._activeLabelIndex = index;
            (_a = labels[index]) === null || _a === void 0 ? void 0 : _a.current.setAttr(_this.getTextStyle(_this.option.activeStyle));
        };
        return _this;
    }
    AxisLabelHighlight.prototype.getDefaultOption = function () {
        return {
            activeStyle: { fontWeight: 'bold' },
            inActiveStyle: {},
        };
    };
    AxisLabelHighlight.prototype.getEvents = function () {
        var _this = this;
        return {
            'plot:mousemove': this.handlePlotMouseMove,
            'plot:touchmove': this.handlePlotMouseMove,
            'plot:touchstart': this.handlePlotMouseMove,
            'plot:mouseleave': function () { return _this._unhighlightLable(_this._activeLabelIndex); },
        };
    };
    AxisLabelHighlight.prototype._unhighlightLable = function (index) {
        var _a;
        var xAxis = this.chart.getComponentModel('coord').grid.xAxis[0];
        var labels = xAxis.getTickLabels();
        (_a = labels[index]) === null || _a === void 0 ? void 0 : _a.current.setAttr(this.getTextStyle(xAxis.getOption().axisLabel));
    };
    return AxisLabelHighlight;
}(Model));
export default AxisLabelHighlight;
